 import React from "react";
import { cn } from "../../../lib/utils";


function StatCard({ title, value, icon, variant = "default", className, chart }) {
  const isPrimary = variant === "primary";

  return (
    <div
      className={cn(
        "rounded-xl p-4 py-6 border border-black/10 flex flex-col justify-between",
        isPrimary ? "bg-primary text-white" : "bg-white text-darkGray",
        className
      )}
    >
      <div className="flex items-center gap-3 mb-3">
        {icon && <span className="text-lg">{icon}</span>}
        <span className="text-lg font-medium">{title}</span>
      </div>

      {value && (
        <div
          className={cn(
            "text-5xl py-2 font-medium mt-2",
            isPrimary ? "text-white" : "text-gray-800"
          )}
        >
          {value}
        </div>
      )}

      {chart && <div className="">{chart}</div>}
    </div>
  );
}

export {StatCard};